import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ELookup } from 'src/app/modules/compliance/constants/eLookup';
import { Messages } from 'src/app/modules/compliance/constants/messages';
import { emptySportSeason } from 'src/app/modules/compliance/constants/prepareEmptyObject';
import { ApiResult } from 'src/app/shared/model/apiresult';
import { LookupService } from 'src/app/modules/maintenance/services/lookup.service';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import { ILookup } from 'src/app/shared/model/Index';
import { ISportSeason } from '../../model/sportseason';
import { Guid } from 'guid-typescript';
import { SportSeasonService } from '../../services/sport-season.service';
import { environment as env } from '@environments/environment'
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { ISportSeasonResult } from '@app/modules/search/model/studentSearchResult';
import { ActivatedRoute, Router } from '@angular/router';
import { ESportParticipationType } from '../../constants/eSportParticipationType';
import { IStudent } from '../../model/student';
import { EFreshmanQualificationType } from '../../constants/eFreshmanQualificationType';
import { EFinancialAidAwardType } from '../../constants/eFinancialAidAwardType';


@Component({
    selector: 'sport-season',
    templateUrl: './sport-season.component.html'
})
export class SportSeasonComponent  implements OnInit, AfterViewInit {
    
    public sportSeason: ISportSeason = emptySportSeason();
    public sportEligibilityList: ILookup[];
    public studentEnrollmentTypeList: ILookup[];
    public sportParticipationList: ILookup[];
    public sportParticipationListAll: ILookup[];
    public sportSeasonList: ILookup[];
    public sportTypeList: ILookup[];
    public ftrs: ILookup[];
    public athleticFinancialAidRenewalTypeList: ILookup[];
    public financialAidAwardTypeList: ILookup[];
    public financialAidAwardExemptionTypeList: ILookup[];
    public redShirtTypeList: ILookup[];
    public institutionTermList: ILookup[];
    public sportSeasonFormGroup: UntypedFormGroup;
    currentDate = new Date();
    studentID: string = '';
    isShown: boolean = false;
    disabled: boolean = false;
    fadRequired:boolean=true;
    reasonRequired:boolean=false;
    displayedColumns: string[] = ['sportType', 'sportSeason', 'isPrimarySport'];
    dataSource = new MatTableDataSource<ISportSeasonResult>();
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @Input() student: IStudent;
    @Input() WriteCompliance:boolean=false;
    @Input() WriteEligibilityFields:boolean=false;
    constructor(
        private _snackBar: MatSnackBar,
        private _formBuilder: UntypedFormBuilder,
        private _lookupservice: LookupService,
        private _sportseasonservice: SportSeasonService,
        private _route: ActivatedRoute,
        private router: Router
        ) {
        //Form Group Initiation.
        this.fillForm(this.sportSeason);
    }
    ngOnInit() {
        this._route.queryParams.subscribe(params => {
            this.studentID = params.id;
        });
        this.getActiveLookups(ELookup.SportType);
        this.getActiveLookups(ELookup.SportSeason);
        this.getActiveLookups(ELookup.StudentEnrollmentType);
        this.getActiveLookups(ELookup.SportEligibilityType);
        this.getActiveLookups(ELookup.SportParticipationType);
        this.getActiveLookups(ELookup.FTR);
        this.getActiveLookups(ELookup.AthleticFinancialAidRenewalType);
        this.getActiveLookups(ELookup.FinancialAidAwardType);
        this.getActiveLookups(ELookup.FinancialAidAwardExemptionType);
        this.getActiveLookups(ELookup.RedShirtType);
        this.getActiveLookups(ELookup.InstitutionTerm);
        this.getSportSeason();
    }

    ngAfterViewInit(): void {
        this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    }   

    cancel() {
        this.sportSeason = emptySportSeason();
        this.fillForm(this.sportSeason);
        this.isShown = false;
    }
    add() {
        this.sportSeason = emptySportSeason();
        this.sportSeason.isPrimarySport = true;
        this.sportSeasonFormGroup.enable();
        this.fillForm(this.sportSeason);
        this.isShown = true;
    }
    edit(id: Guid) {
        this.isShown = true;
        this.getSportSeasonById(id);
        this.sportSeasonFormGroup.get('sportTypeId').disable();
        this.sportSeasonFormGroup.get('sportSeasonId').disable();
    }
    delete(id: Guid) {
        this.deleteSportSeasonById(id);
    }
    public onSelectParticipationChange(event: any) {
        if (event.value === ESportParticipationType.Manager) {
            this.sportSeasonFormGroup.get('financialAidAwardTypeId').setValue(null);
            this.sportSeasonFormGroup.controls["financialAidAwardTypeId"].clearValidators();
            this.fadRequired=false;
        }
        else
        {
            this.fadRequired=true;
            this.sportSeasonFormGroup.controls["financialAidAwardTypeId"].setValidators(Validators.required);
        }
        this.sportSeasonFormGroup.controls["financialAidAwardTypeId"].updateValueAndValidity();
    }
    public onSelectEnrollmentChange(event: any) {
        let participantTypeId = this.sportSeasonFormGroup.controls["participationTypeId"].value;
        if(participantTypeId !== ESportParticipationType.Manager)
        {
            if (this.student.hasScholarship) {
                if (event.value === EFreshmanQualificationType.Freshman || event.value === EFreshmanQualificationType.Transfer) {
                    this.sportSeasonFormGroup.get('financialAidAwardTypeId').setValue(EFinancialAidAwardType.Initial);
                }
                else if (event.value === EFreshmanQualificationType.Returnee) {
                    this.sportSeasonFormGroup.get('financialAidAwardTypeId').setValue(EFinancialAidAwardType.Overall);
                }
            }
            if (!this.student.hasScholarship) {
                this.sportSeasonFormGroup.get('financialAidAwardTypeId').setValue(EFinancialAidAwardType.Walkon);
            }
        }
        this.reasonRequired=false;
        this.sportSeasonFormGroup.controls["financialAidAwardExemptionTypeId"].clearValidators();
        this.sportSeasonFormGroup.controls["financialAidAwardExemptionTypeId"].updateValueAndValidity();
    }
    public onSelectFadCounterChange(event: any) {
        if (event.value === EFinancialAidAwardType.Exempt) {
            this.reasonRequired=true;
            this.sportSeasonFormGroup.controls["financialAidAwardExemptionTypeId"].setValidators(Validators.required);
        }
        else
        {
            this.reasonRequired=false;
            this.sportSeasonFormGroup.controls["financialAidAwardExemptionTypeId"].clearValidators();
        }
        this.sportSeasonFormGroup.controls["financialAidAwardExemptionTypeId"].updateValueAndValidity();
    }
    
    private getSportSeason() {
        this._sportseasonservice.get(Guid.parse(this.studentID).toJSON().value).subscribe((result: ApiResult<ISportSeasonResult[]>) => {
            if (result.validationErrors == null && result.value != null) {
                this.dataSource = new MatTableDataSource<ISportSeasonResult>(result.value);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            }
        }, error => console.error(error));
    }

    private getActiveLookups(tableName: string) {
        this._lookupservice.getActiveLookups(tableName).subscribe((result: ApiResult<ILookup[]>) => {
            if (result.validationErrors == null) {
                switch (tableName) {
                    case ELookup.InstitutionTerm:
                        this.institutionTermList = result.value;
                        break;
                    case ELookup.StudentEnrollmentType:
                        this.studentEnrollmentTypeList = result.value;
                        break;
                    case ELookup.SportEligibilityType:
                        this.sportEligibilityList = result.value;
                        break;
                    case ELookup.SportParticipationType:
                        this.sportParticipationList = result.value;
                        this.sportParticipationListAll = result.value;
                        break;
                    case ELookup.SportSeason:
                        this.sportSeasonList = result.value;
                        break;
                    case ELookup.FTR:
                        this.ftrs = result.value;
                        break;
                    case ELookup.SportType:
                        this.sportTypeList = result.value;
                        break;
                    case ELookup.AthleticFinancialAidRenewalType:
                        this.athleticFinancialAidRenewalTypeList = result.value;
                        break;
                    case ELookup.FinancialAidAwardType:
                        this.financialAidAwardTypeList = result.value;
                        break;
                    case ELookup.FinancialAidAwardExemptionType:
                        this.financialAidAwardExemptionTypeList = result.value;
                        break;
                    case ELookup.RedShirtType:
                        this.redShirtTypeList = result.value;
                        break;
                    default:
                        break;
                }
            }
        }, error => console.error(error));
    }

    private getSportSeasonById(id: Guid) {
        this._sportseasonservice.getSportSeasonById(id).subscribe((result: ApiResult<ISportSeason>) => {
            if (result.validationErrors == null && result.value != null) {
                this.sportSeason = result.value;
                this.fillForm(this.sportSeason)

                // do not require FAD if season is for a Manager
                if (this.sportSeason.participationTypeId === ESportParticipationType.Manager) {
                    this.sportSeasonFormGroup.get('financialAidAwardTypeId').setValue(null);
                    this.sportSeasonFormGroup.controls["financialAidAwardTypeId"].clearValidators();
                    this.fadRequired=false;
                }

                // do not show 'removed from team' if athlete has fractional aid on their primary sport.
                if(this.sportSeason.fractionalAid > 0 && this.sportSeason.isPrimarySport)
                {
                    this.sportParticipationList = this.sportParticipationList.filter(t => (t.code.indexOf('X') != 0));
                }
                else
                {
                    this.sportParticipationList = this.sportParticipationListAll;
                }
            }
        }, error => console.error(error));
    }
    private deleteSportSeasonById(id: Guid) {
        this._sportseasonservice.delete(id).subscribe((result: ApiResult<ISportSeason>) => {
            if (result.validationErrors == null) {
                this.getSportSeason()
            }
            else {
                this.edit(id);
                this.notifyWarnings(result.validationErrors);
            }
        }, error => console.error(error));
    }

    private fillForm(sportSeasonInfo: ISportSeason) {
        this.sportSeasonFormGroup = this._formBuilder.group(
            {
                studentId: [sportSeasonInfo.studentId],
                tenantId: [sportSeasonInfo.tenantId],
                studentInstitutionSeasonId: [sportSeasonInfo.studentInstitutionSeasonId],
                sportTypeId: [sportSeasonInfo.sportTypeId],
                sportSeasonId: [sportSeasonInfo.sportSeasonId],
                fallEligibilityTypeId: [sportSeasonInfo.fallEligibilityTypeId],
                fallEligibilityDate: [sportSeasonInfo.fallEligibilityDate],
                participationTypeId: [sportSeasonInfo.participationTypeId],
                springEligibilityTypeId: [sportSeasonInfo.springEligibilityTypeId],
                springEligibilityDate: [sportSeasonInfo.springEligibilityDate],
                freshmanQualifierTypeId: [sportSeasonInfo.freshmanQualifierTypeId],
                enrollmentTypeId: [sportSeasonInfo.enrollmentTypeId],
                ncaalegislationCode: [sportSeasonInfo.ncaalegislationCode], //TODO
                redShirtTypeId: [sportSeasonInfo.redShirtTypeId],
                isPrimarySport: [sportSeasonInfo.isPrimarySport],
                isMedicalHardship: [sportSeasonInfo.isMedicalHardship],
                quitTeamDate: [sportSeasonInfo.quitTeamDate],
                financialAidAwardTypeId: [sportSeasonInfo.financialAidAwardTypeId,Validators.required],
                fractionalAid: [this.sportSeason.fractionalAid],
                fractionalAidExclusion: [this.sportSeason.fractionalAidExclusion],
                financialAidAwardExemptionTypeId: [sportSeasonInfo.financialAidAwardExemptionTypeId],
                hasLetter: [sportSeasonInfo.hasLetter],
                fallAthleticFinancialAidRenewalTypeId: [sportSeasonInfo.fallAthleticFinancialAidRenewalTypeId],
                fallAthleticFinancialAidRenewalDate: [sportSeasonInfo.fallAthleticFinancialAidRenewalDate],
                isNinthSemester: [sportSeasonInfo.isNinthSemester],
                springAthleticFinancialAidRenewalTypeId: [sportSeasonInfo.springAthleticFinancialAidRenewalTypeId],
                springAthleticFinancialAidRenewalDate: [sportSeasonInfo.springAthleticFinancialAidRenewalDate],
                exhaustedEligibilityTermId: [sportSeasonInfo.exhaustedEligibilityTermId],
                squadComment: [sportSeasonInfo.squadComment],
            });
    }
    public changeFallEligibilityValue(event:any)
    {
        this.sportSeasonFormGroup.get('fallEligibilityDate').setValue(new Date());
    }
    public changeSpringEligibilityValue(event:any)
    {
        this.sportSeasonFormGroup.get('springEligibilityDate').setValue(new Date());
    }
    public onSubmit() {
        this.sportSeason = this.sportSeasonFormGroup.value as ISportSeason;
        if (this.sportSeason.studentInstitutionSeasonId !== null) {
            this._sportseasonservice.put(this.sportSeason).subscribe((result: ApiResult<number>) => {
                if (result.statusCode == 200) {
                    this.notify();
                    this.getSportSeason();
                }
                else {
                    this.notifyWarnings(result.validationErrors);
                }
            }, error => console.error(error));
        }
        else {
            this.sportSeason.studentId = Guid.parse(this.studentID).toJSON().value;
            this.sportSeason.tenantId = Guid.parse(env.tenantId).toJSON().value;
            this.sportSeason.studentInstitutionSeasonId = Guid.createEmpty().toJSON().value;
            this._sportseasonservice.post(this.sportSeason).subscribe((result: ApiResult<number>) => {
                if (result.statusCode == 200) {
                    this.notify();
                    this.getSportSeason();
                    this.router.navigate(['/compliance', 'documents'], { queryParams: {id: this.studentID}});
                }
                else {
                    this.sportSeason.studentInstitutionSeasonId = null;
                    this.notifyWarnings(result.validationErrors);
                }
            }, error => console.error(error));
        }
    }

    notifyWarnings(message: string[]) {
        let snackBarRef = this._snackBar.open(message[0], "Close", {
            duration: 5000,
            panelClass: ['red-snackbar']
        });
        snackBarRef.afterDismissed().subscribe(() => {
        });
    }
    notify() {
        let snackBarRef = this._snackBar.open(Messages.SportSeasonSaved, "Close", {
            duration: 2000,
        });
        snackBarRef.afterDismissed().subscribe(() => {
        });
    }

    evalBind(data:ILookup,currentValue:number){
        if(data.id==currentValue){
            return true;
        }
      return !data.disabled;
    }

}
